import React from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from "@mui/material";

interface ConfirmationDialogProps {
    open: boolean;
    title: string;
    description: React.ReactNode;
    cancelLabel?: string;
    confirmLabel?: string;
    confirmColor?: "primary" | "secondary" | "error" | "warning" | "info" | "success" | "inherit";
    confirmDisabled?: boolean;
    titleId?: string;
    descriptionId?: string;
    onCancel: () => void;
    onConfirm: () => void;
}

export function ConfirmationDialog({
    open,
    title,
    description,
    cancelLabel = "Cancel",
    confirmLabel = "Confirm",
    confirmColor = "primary",
    confirmDisabled = false,
    titleId,
    descriptionId,
    onCancel,
    onConfirm,
}: ConfirmationDialogProps) {
    return (
        <Dialog
            open={open}
            onClose={onCancel}
            aria-labelledby={titleId}
            aria-describedby={descriptionId}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle id={titleId}>{title}</DialogTitle>
            <DialogContent>
                <DialogContentText id={descriptionId}>{description}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel}>{cancelLabel}</Button>
                <Button
                    variant="contained"
                    color={confirmColor}
                    onClick={onConfirm}
                    disabled={confirmDisabled}
                    autoFocus
                >
                    {confirmLabel}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
